import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ButtonModule, CheckboxModule, InputModule, RadioModule, SelectModule, TextareaModule } from '@sag-ui';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InvoiceErrorDomesticForm, InvoiceErrorDomesticFormGroup } from '../../../models/cod-create.model';
import { AttachmentsInputComponent } from '../../../../shared/components/attachments-input/attachments-input.component';
import { filter, tap } from 'rxjs';
import { InvoiceIssueTypeDetail } from '@cod-monorepo/interfaces';
import { Store } from '@ngxs/store';
import { AddCurrentCodLine, AddErrorMessage, RemoveErrorMessage } from '../../../state/cod.action';
import { WorkflowError } from '../../../../shared/enums/workflow-error';
import { ManagerSelectComponent } from '../../../../shared/components/manager-select/manager-select.component';

@Component({
    selector: 'app-cod-invoice-error-domestic-step',
    templateUrl: './invoice-error-domestic.component.html',
    imports: [
        CommonModule,
        SelectModule,
        InputModule,
        FormsModule,
        ReactiveFormsModule,
        RadioModule,
        CheckboxModule,
        ButtonModule,
        TextareaModule,
        AttachmentsInputComponent,
        ManagerSelectComponent
    ],
    standalone: true
})
export class CodInvoiceErrorDomesticStepComponent implements OnInit {
    @Input() invoiceErrorDomesticForm: FormGroup<InvoiceErrorDomesticFormGroup> | undefined;

    private relatedCallTrackingNumberTouched = false;
    public invoiceErrorDetailTypes = InvoiceIssueTypeDetail;

    constructor(private store: Store) {}

    ngOnInit(): void {
        this.initFinancialAdjustmentChangesListener();
        this.initCallTagTrackingNumberTouchedListener();
        this.initRelatedDocumentsListener();
    }

    public isDefined(control: keyof InvoiceErrorDomesticForm): boolean {
        return this.invoiceErrorDomesticForm?.controls[control].value !== null;
    }

    public isTrue(control: keyof InvoiceErrorDomesticForm): boolean {
        return this.invoiceErrorDomesticForm?.controls[control].value === true;
    }

    public isFalse(control: keyof InvoiceErrorDomesticForm): boolean {
        return this.invoiceErrorDomesticForm?.controls[control].value === false;
    }

    public handleConfirm() {
        if (this.invoiceErrorDomesticForm?.valid) {
            this.store.dispatch(new AddCurrentCodLine());
        }
    }

    public isValid(): boolean {
        return this.invoiceErrorDomesticForm?.valid ?? false;
    }

    private initFinancialAdjustmentChangesListener(): void {
        this.invoiceErrorDomesticForm?.controls.financialAdjustment.valueChanges
            .pipe(
                filter(value => value === false),
                tap(() => {
                   this.invoiceErrorDomesticForm?.controls.adjustmentAmount.setValue(0);
                   this.invoiceErrorDomesticForm?.controls.filedWithin30Days.setValue(null);
                   this.invoiceErrorDomesticForm?.controls.managerApprovedRequest.setValue(null);
                })
            )
            .subscribe();
    }

    private initCallTagTrackingNumberTouchedListener(): void {
        this.invoiceErrorDomesticForm?.controls.callTagTrackingNumber.valueChanges
            .pipe(
                filter(() => !this.relatedCallTrackingNumberTouched),
                tap(() => {
                    this.store.dispatch(new AddErrorMessage(WorkflowError.UPLOAD_PROOF));

                    this.relatedCallTrackingNumberTouched = true;
                })
            )
            .subscribe();
    }

    private initRelatedDocumentsListener(): void {
        this.invoiceErrorDomesticForm?.controls.relatedDocuments.valueChanges
            .pipe(
                filter(value => !!value && value.length > 0),
                tap(() => this.store.dispatch(new RemoveErrorMessage(WorkflowError.UPLOAD_PROOF)))
            )
            .subscribe();
    }
}
